import moment from "moment";

export const getBanner = () => {
    if (localStorage.getItem("banner")) {
        var c = moment().format("M/D/YYYY");
        var d = moment(localStorage.getItem("banner"));
        var diffDays = d.diff(c, "days");
        if (diffDays <= 0) return false;
        return true;
    } else {
        return false;
    }
};

export const setCurrentDate = () => {
    var c = moment().format("M/D/YYYY");
    localStorage.setItem("banner", c);
};
